import React from 'react';
import { useServiceCatalogId } from '../../useServiceCatalogId';
import useKPIService from '../useKPIService';
import { DataGridLayout, Filters, List } from 'framework/list';
import moment from 'moment';
import { DATE_FORMAT } from 'framework/utils';
import { Box } from '@mui/material';
import KPIValueListField from '../shared/fields/KPIValueListField';
import KpiStructureStaticFilters from './filter/KpiStructureStaticFilters';

const ActiveKpiStructure = () => {
  const id = useServiceCatalogId();
  const { getActiveStructure } = useKPIService();
  const currentMonth = moment().startOf('month').format(DATE_FORMAT.API_ONLY_MONTH);

  return (
    <Box sx={{ minHeight: '200px', position: 'relative' }}>
      <List
        getDataMethod={async req => getActiveStructure(id, req)}
        defaultFilter={{
          period: {
            eq: currentMonth,
          },
        }}
      >
        <>
          <Filters>
            <KpiStructureStaticFilters />
          </Filters>
          <DataGridLayout showTotal={false} isSmallTable>
            <KPIValueListField source="kpiParameters" dateSource="effectiveDate" />
          </DataGridLayout>
        </>
      </List>
    </Box>
  );
};

export default ActiveKpiStructure;
